export interface ISensorHardware {
  id?: number;
  manufacturer?: string | null;
  model?: string | null;
  description?: string | null;
  equation?: string | null;
}

export const defaultValue: Readonly<ISensorHardware> = {};
